
import { mapGetters } from "vuex";

export default {
  name: "UiScrollableSlider",
  props: {
    itemsList: {
      type: Array,
      default: () => [],
    },
    slidesCount: {
      type: [String, Number],
      default: 0,
    },
    listClasses: {
      type: [String, Array, Object],
      default: "",
    },
    gapX: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      mobileScrollOptions: {
        scrollLeft: 0,
        scrollWidth: 0,
        clientWidth: 0,
      },
      scrollBarOptions: {
        scrollWidth: 0,
        thumbWidth: 0,
        spaceLeft: 0,
      },
    };
  },
  watch: {
    "appBreakpoints.mdAndDown"(val) {
      if (val) {
        this.getElementsData();
      }
    },
  },
  computed: {
    ...mapGetters({
      appBreakpoints: "general/getAppBreakpoints",
    }),
    hidePagination() {
      // if (!this.itemsList?.length) {
      //   return false;
      // }
      // return Number(this.slidesCount) >= this.itemsList.length;
      return true;
    },
  },
  mounted() {
    this.getElementsData();
  },
  methods: {
    handleScroll(e) {
      this.mobileScrollOptions = {
        scrollLeft: e.target.scrollLeft,
        scrollWidth: e.target.scrollWidth,
        clientWidth: e.target.clientWidth,
      };
      this.scrollBarOptions.spaceLeft =
        (this.mobileScrollOptions.scrollLeft /
          this.mobileScrollOptions.scrollWidth) *
        100;
    },

    getElementsData() {
      if (!this.$refs.mobileScroll || !this.$refs.scrollBar) {
        return;
      }
      this.mobileScrollOptions = {
        scrollLeft: this.$refs.mobileScroll.scrollLeft,
        scrollWidth: this.$refs.mobileScroll.scrollWidth,
        clientWidth: this.$refs.mobileScroll.clientWidth,
      };
      this.scrollBarOptions = {
        scrollWidth: this.$refs.scrollBar?.scrollWidth || 0,
        thumbWidth:
          (this.mobileScrollOptions.clientWidth /
            this.mobileScrollOptions.scrollWidth) *
          100,
        spaceLeft: 0,
      };
    },
  },
};
